import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConciliationExtractService {
  private readonly API = `${environment.api_url}/conciliacaoExtrato`;

  constructor(private http: HttpClient) {}

  donwloadExcel(): Observable<any> {
    return this.http.get(`${this.API}/DownloadExcel`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        responseType: 'blob',
      }),
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }
}
